/* Starglass: rotating headline words. The two words take turns changing. */
(function(){
  document.querySelectorAll('[data-sg-rotate]').forEach(function(h){
    var a=h.querySelector('[data-w="a"]'),b=h.querySelector('[data-w="b"]');
    if(!a||!b)return;
    function L(el){try{return JSON.parse(el.getAttribute('data-words')||'[]').map(function(w){return String(w).trim()}).filter(Boolean)}catch(e){return[]}}
    var A=L(a),B=L(b);
    if(A.length<2&&B.length<2)return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var ia=0,ib=0,turn=false,ms=parseFloat(h.getAttribute('data-ms'))||1700;
    function swap(el,list,i){el.classList.add('is-out');setTimeout(function(){el.textContent=list[i];el.classList.remove('is-out')},180)}
    setInterval(function(){
      if(turn&&B.length>1){ib=(ib+1)%B.length;swap(b,B,ib)}
      else if(A.length>1){ia=(ia+1)%A.length;swap(a,A,ia)}
      turn=!turn;
    },ms);
  });
})();
